import { ImageIcon, XIcon } from 'lucide-react';
import FormField from './FormField';
import OptionImageUpload from '@/components/snap/OptionImageUpload';

interface OptionFieldProps {
  index: number;
  title: string;
  description: string;
  imageUrl: string;
  onTitleChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onImageUrlChange: (value: string) => void;
  onRemove: () => void;
  canRemove: boolean;
}

export default function OptionField({
  index,
  title,
  description,
  imageUrl,
  onTitleChange,
  onDescriptionChange,
  onImageUrlChange,
  onRemove,
  canRemove
}: OptionFieldProps) {
  return (
    <div className="relative bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">Option {index + 1}</h3>
        {canRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-gray-400 hover:text-red-500 transition-colors p-1 hover:bg-red-50 rounded-full"
          >
            <XIcon className="h-5 w-5" />
          </button>
        )}
      </div>
      <div className="space-y-4">
        <FormField label="Title" required>
          <input
            type="text"
            value={title}
            onChange={(e) => onTitleChange(e.target.value)}
            className="block w-full px-4 py-3 rounded-lg border border-gray-300 bg-white shadow-sm focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
            placeholder="Option title"
            required
          />
        </FormField>

        <FormField label="Description" optional>
          <textarea
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            rows={2}
            className="block w-full px-4 py-3 rounded-lg border border-gray-300 bg-white shadow-sm focus:border-primary-500 focus:ring-2 focus:ring-primary-500 focus:ring-opacity-50"
            placeholder="Describe this option"
          />
        </FormField>

        <FormField label="Image" optional>
          <OptionImageUpload
            currentImageUrl={imageUrl}
            onImageUpdated={(newUrl) => {
              onImageUrlChange(newUrl);
            }}
            optionId={`${index}`}
          />
        </FormField>
      </div>
    </div>
  );
}